import React from 'react';

import {pure} from 'recompose';

import Avatar from './Avatar.js';

import "./Navbar.css";

const Navbar = (props) => (
  <div className="navbar" style={{...props.style}}>
    <h2 className="navbar-heading">
      DrGreene <span style={{color: "#4fc3ea"}}> AI </span>
    </h2>
    <div className="space" />
    <Avatar for='user' size={40} style={{marginRight: 24}}/>
  </div>
)

export default pure(Navbar);



// WEBPACK FOOTER //
// ./src/components/Navbar.js